// 仅移动端启用 rem；PC 保持 16px，不影响现有 px 样式
(function () {
    const BASE_WIDTH = 375; // 设计稿基准（常用 375）
    const BASE_FONT = 16;
  
    function setRem() {
      const width = Math.min(document.documentElement.clientWidth, 768);
      if (width > 768) {
        document.documentElement.style.fontSize = BASE_FONT + "px";
        return;
      }
      const fontSize = (width / BASE_WIDTH) * BASE_FONT;
      document.documentElement.style.fontSize = fontSize + "px";
    }
  
    setRem();
    window.addEventListener("resize", setRem);
    window.addEventListener("orientationchange", setRem);
  })();
  